var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-level1',_vm._b({},'layout-level1',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }